import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {ConcreteHierarchyItemInterface} from "../../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {Item} from "../../models/Item";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Observable, Subject, Subscription} from "rxjs";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {map} from "rxjs/operators";
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import { StoryService } from 'src/app/services/storyService/story.service';

@Component({
  selector: 'app-placed-item',
  templateUrl: './placed-item.component.html',
  animations: [
    trigger('openedAnimation', [
      // ...
      state('opened', style({
        height: '*',
        visibility: 'visible',
        overflow: 'hidden'
      })),
      state('closed', style({
        height: '0px',
        visibility: 'hidden',
        overflow: 'hidden'
      })),
      transition('opened <=> closed', [
        animate('0.5s ease')
      ]),
    ])
  ],
  styleUrls: ['./placed-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlacedItemComponent implements OnInit, AfterViewInit, OnDestroy{

  @Input() item:ConcreteHierarchyItemInterface;
  @Output() contentChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  public topClHint = null;
  public isOpened = false;
  public Yiit = Yiit;
  public isTopCl = false;
  public currentChildrenList:ConcreteHierarchyItemInterface[] = [];
  public hasChildren = false;
  public isGrayedOut = false;
  public selectedChildParent = null;
  public selected = null;
  private isInited = false;
  private subscriptions: Subscription = new Subscription();
  public openedGroups = [];
  public hiddenGroups = [];
  public selectedParentIdForTopTemplate = null;
  private groupVisibilityChange = new Subject();

  constructor(
    private uiAdapter: UiAdapterService,
    private cd: ChangeDetectorRef,
    private concreteLayerService: ConcreteLayerService,
    private view: CesiumAdapterService,
    private storyService:StoryService
  ) {}

  ngOnInit(): void {

    this.subscriptions.add(this.uiAdapter.selectedItem$.subscribe((selectedItem)=>{
      this.selected = (selectedItem) ? selectedItem.getCHIId() : null;
      this.selectedChildParent = (this.uiAdapter.selectedParentId && 'ConcreteLayer-'+this.uiAdapter.selectedParentId == this.item.getCHIId());
      if (this.item instanceof ConcreteLayer){
        this.isGrayedOut = !this.selectedChildParent && this.selected != this.item.getCHIId() && !this.isTopCl;

        if (this.isTopCl){
          if (selectedItem instanceof ConcreteLayer){
            this.selectedParentIdForTopTemplate = !(selectedItem.getCHIId() == "ConcreteLayer-TOP")
          }
          else{
              this.selectedParentIdForTopTemplate = !(selectedItem.getParentConcreteId() == null);
          }
        }
      }
      this.cd.detectChanges();
    }));

    this.initListeners();
  }

  isVisibleItem(){
    if (this.item instanceof Item){
      return this.item.getSubjectValue(Item.SUBJECT_LEFT_SIDEBAR_MAIN_VISIBILITY) != false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.cd.detach();
    this.subscriptions.unsubscribe();
  }

  public changeGroupVisibility(event, group){
    event.preventDefault();
    event.stopImmediatePropagation();
    let index = this.hiddenGroups.indexOf(group.key);
    if (index < 0){
      this.hiddenGroups.push(group.key);
      group.value.forEach((item)=>{
        this.setItemVisibility(item,false);
      })
    }
    else{
      this.hiddenGroups.splice(index, 1);
      group.value.forEach((item)=>{
        this.setItemVisibility(item,true);
      })
    }
    this.storyService.hiddenGroups = this.hiddenGroups;
  }

  public contentChangedHandler(e) {
    this.cd.detectChanges();
  }

  public listItemIdentifier(index, item) {
    let k = [item.key];
    item.value.forEach(it => {
      if (it instanceof Item) {
        k.push(it.config.getInputProp('__timeline', 'value'));
      }
    });
    return k.join('-');
  }

  private setItemVisibility(item, flag){
    if (item instanceof Item){
      item.setVisibility(flag);
    }
    else if(item instanceof ConcreteLayer){
      (flag) ? this.concreteLayerService.show(item) : this.concreteLayerService.hide(item);
    }
  }

  public centerMapAtObj(item){
    if (item instanceof Item){
      item.centerOnObj();
    }
    this.cd.detectChanges();
  }

  public toggleOpenedGroups(groupName){
    let index = this.openedGroups.indexOf(groupName);
    if ( index < 0){
      this.openedGroups.push(groupName);
    }
    else {
      this.openedGroups.splice(index, 1);
    }
  }

  public isOpenedGroup(groupName){
    return this.openedGroups.includes(groupName);
  }

  public isHiddenGroups(groupName){
    return this.hiddenGroups.includes(groupName);
  }

  // public onChildSelected(data){
  //   this.isOpened = true;
  //   this.cd.markForCheck();
  //   this.uiAdapter.selectedParent = this.item;
  // }

  private initListeners(){
    if (this.item instanceof Item){


        this.subscriptions.add(this.item.config.subject.subscribe(()=>{
          this.contentChanged.emit(true);
          console.log('timeline FIRE!!!!!');
          this.cd.detectChanges();
        }));
        this.subscriptions.add(this.item.config.serverUpdate.subscribe(()=>{
          this.cd.detectChanges();
        }));
        this.subscriptions.add(this.item.getSubject(Item.SUBJECT_VISIBILITY).subscribe((visibility)=>{
          this.isGrayedOut = !visibility;
          this.cd.detectChanges();
        }))
    }
    else{
      this.subscriptions.add(this.concreteLayerService.listChanged.subscribe(()=>{
        this.cd.detectChanges();
      }));
    }
  }

  ngAfterViewInit():void{
    if (this.item.getCHIId && this.item.getCHIId() == 'ConcreteLayer-TOP'){
      let div = document.createElement('div');
      div.innerHTML = window['HINT_OUTDOOR'];
      this.topClHint =  div.innerText;
      this.isTopCl = true;
    }

    this.subscriptions.add(this.item.getChildren().subscribe((config)=>{
        if (config && config.length){
          this.hasChildren = true;
          if (this.item.getCHIId && this.item.getCHIId() == 'ConcreteLayer-TOP' && !this.isInited){
            this.isOpened = true;
            this.isInited = true;
          }
          this.currentChildrenList = config.filter((i)=>{
            if (i instanceof ConcreteLayer){
              return !i.isOverlay
            }
            return true;
          });
          this.cd.detectChanges();
        }
        else{
          this.currentChildrenList = [];
          this.hasChildren = false;
          this.cd.detectChanges();
        }
    }));
    this.cd.detectChanges();
  }

  isActive(){
    if ((this.item instanceof ConcreteLayer) || (this.item instanceof Item)) {
      return this.selected && this.item.getCHIId() == this.selected;
    }
    return false;
  }

  toggleOpenStatus(){
    this.isOpened = !this.isOpened;
    this.cd.detectChanges();
  }

  /**
   * Combined list of items and floor layouts (concrete layers)
   * But CAD overlays are excluded as they can't be someone's children (ONE-719)
   */
  getChildren():Observable<ConcreteHierarchyItemInterface[]>{
    return this.item.getChildren().pipe(map((items) => {
      return items.filter((item) => {
        if (item instanceof ConcreteLayer) {
          if (item.isOverlay) {
            return false;
          }
        }
        return true;
      });
    }));
    // return this.concreteService.getConcreteHierarchyChildren(item);
  }

  isItem(){
    return this.item instanceof Item;
  }

  getItemImg(){
      // @ts-ignore
      return this.item.config.getObjectConfig().getMapIcon() || this.item.config.getTool().menu_icon || null;
  }

  getItemDetails(){
    this.item.onSelect();
    // this.onItemSelected.emit(true);
    this.uiAdapter.selectedItem$ = this.item;
  }
}
